{
  "validEmailsTitle": "Correos/Dominios válidos",
  "newEmailPlaceholder": "Nuevo correo/dominio",
  "addButton": "Añadir",
  "emailToTestPlaceholder": "Correo de prueba",
  "testButton": "Prueba",
  "testPassed": "Aprobado. Este correo electrónico tendrá acceso permitido.",
  "testFailed": "Error. Este correo no tendrá acceso permitido.",
  "passwordWhitelistTitle": "Lista blanca de autenticación por contraseña",
  "newEmailWhitelistPlaceholder": "Nuevo correo",
  "defaultReason": "Añadido vía admin",
  "whitelistTestPassed": "Aprobado. Este correo puede usar autenticación con contraseña.",
  "whitelistTestFailed": "Error. Este correo debe usar inicio de sesión de Microsoft/Google."
}
